import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { Account} from "model";
import TASPositivePayAddChecksPage from "components/pages/TASPositivePayAddChecksPage";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

/**
 * @name CapturePositivePayAddACheckPPAddCheckAddChecks
 * @returns {React.Component}
 * @description A capture in the "Positive Pay - Add a Check" capture group.
 */
export default function CapturePositivePayAddACheckPPAddCheckAddChecks(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasBusinessAccounts = Account.hasBusinessAccounts(branding);

    if(!hasBusinessAccounts) {
        const message = Account.businessOnlyBrandingErrorMessage;
        return <CaptureNotShownView message={ message }/>;
    }

    return <TASPositivePayAddChecksPage />;
}